import React from 'react';
import classnames from 'classnames/bind';
import { InfoIcon, Tooltip as UIKitTooltip } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classnames.bind(styles);
export var Tooltip = function Tooltip(_ref) {
  var isTooltip = _ref.isTooltip,
    _ref$help = _ref.help,
    help = _ref$help === void 0 ? '' : _ref$help;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('tooltip')
  }, isTooltip && /*#__PURE__*/React.createElement(UIKitTooltip, {
    message: help,
    position: "left"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    size: "s"
  })));
};